// Public company details supplied by the platform owner. A city is not a
// registered postal address; that remains a separate deployment setting.
export const companyDetails = {
  name: "ANDREOU INNOVATIONS LTD",
  registrationNumber: "ΗΕ 482315",
  website: "https://andreouinnovations.com/",
  city: "Nicosia",
  countryCode: "CY",
  location: { el: "Λευκωσία, Κύπρος", en: "Nicosia, Cyprus" }
} as const;
